/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100InternalArea } from './Ptw100InternalArea';
import {
    Ptw100InternalAreaFromJSON,
    Ptw100InternalAreaFromJSONTyped,
    Ptw100InternalAreaToJSON,
} from './Ptw100InternalArea';

/**
 * 
 * @export
 * @interface OneOfPropertyOfPtw100InternalAreaOptions
 */
export interface OneOfPropertyOfPtw100InternalAreaOptions {
    [key: string]: Ptw100InternalArea | any;
    /**
     * 
     * @type {string}
     * @memberof OneOfPropertyOfPtw100InternalAreaOptions
     */
    $type?: OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum;
}


/**
 * @export
 */
export const OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum = {
    SystemCollectionsGenericDictionary2SystemStringSystemPrivateCoreLibPtwDomainItemTypeCatalogInfrastructureDescriptionsEnumsPtw100InternalAreaPtwDomainItemTypeCatalogInfrastructureSystemPrivateCoreLib: 'System.Collections.Generic.Dictionary`2[[System.String, System.Private.CoreLib],[Ptw.DomainItemTypeCatalog.Infrastructure.Descriptions.Enums.Ptw100InternalArea, Ptw.DomainItemTypeCatalog.Infrastructure]], System.Private.CoreLib'
} as const;
export type OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum = typeof OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum[keyof typeof OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum];


/**
 * Check if a given object implements the OneOfPropertyOfPtw100InternalAreaOptions interface.
 */
export function instanceOfOneOfPropertyOfPtw100InternalAreaOptions(value?: unknown): value is OneOfPropertyOfPtw100InternalAreaOptions {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OneOfPropertyOfPtw100InternalAreaOptionsTypeEnum)[0];
}

export function OneOfPropertyOfPtw100InternalAreaOptionsFromJSON(json: any): OneOfPropertyOfPtw100InternalAreaOptions {
    return OneOfPropertyOfPtw100InternalAreaOptionsFromJSONTyped(json, false);
}

export function OneOfPropertyOfPtw100InternalAreaOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneOfPropertyOfPtw100InternalAreaOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function OneOfPropertyOfPtw100InternalAreaOptionsToJSON(value?: OneOfPropertyOfPtw100InternalAreaOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value.$type,
    });
}

